export const AdminUsersEndpoints = {
  RETRIEVE_ADMIN_USERS: '/api/admin/adminUser/all',
  GET_ADMIN_USER: '/api/admin/adminUser',
  CREATE_USER: '/api/admin/adminUser',
  UPDATE_ADMIN_USER: '/api/admin/adminUser',
  DELETE_ADMIN_USER: '/api/admin/adminUser',
  TOGGLE_ENABLED: '/api/admin/adminUser/enabled',
  RESET_PASSWORD: '/api/admin/adminUser/resetPassword',
  SET_TEMPORARY_PASSWORD: '/api/admin/adminUser/setTemporaryPassword',
};
